import React, { ReactNode } from 'react';

import './custom-lesson-view__info.scss';

interface Props {
    children: ReactNode;
}

export const CustomLessonViewInfo = React.memo(({ children }: Props) => {
    return <div className="custom-lesson-view__info">{children}</div>;
});
